import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import WaiterPage from 'modules/restaurant/waiter/WaiterPage';

export default function DashRestaurantWaiter() {
    return (
        <DashEstablishmentContainer title='Comandas'>
            <WaiterPage />
        </DashEstablishmentContainer>
    );
}
